import classNames from "classnames";
import { RichText } from "components/RichTextWidget";
import { useTranslation } from "features/translations";
import { Action, Container, Heading2, Heading5, Icon } from "shared/components";

import { useCollectedEventsRender } from "./Content027.hook.js";
import styles from "./Content027.module.scss";
import { DefaultItem } from "./DefaultItem";
import { Item } from "./Item";

export const Content027 = ({ payload }) => {
  const { t } = useTranslation();
  const title = payload?.title ?? "";
  const description = payload?.description ?? "";

  const { feed, isCompleted, renderNext, itemsAmount } =
    useCollectedEventsRender({
      payload,
    });

  const [event, ...rest] = feed;

  return (
    <div className={styles.wrapper}>
      <Container>
        <div className={styles.top}>
          <Heading2 className={styles.title}>{title}</Heading2>
          {description && (
            <RichText
              value={description}
              className={styles.description}
              color="dark"
            />
          )}
        </div>
        {feed.length > 0 ? (
          <>
            <div className={styles.content}>
              <div className={styles.list}>
                <DefaultItem item={event} itemsAmount={itemsAmount} />
                {[...rest].map((event) => {
                  return <Item item={event} key={event.id} />;
                })}
              </div>
            </div>
            {!isCompleted && (
              <Action onClick={renderNext} className={styles.more}>
                <div className={styles.loader}>
                  <div className={classNames(styles["loader-wrapper"])}>
                    {t("lazyRendering")}
                    <Icon className={styles.icon} name="loader" />
                  </div>
                </div>
              </Action>
            )}
          </>
        ) : (
          <Heading5 appearance="bold">{t("empty_events")}</Heading5>
        )}
      </Container>
    </div>
  );
};

export default Content027;
